import React from 'react';
import { Button, EmptyState } from '@roger/ui-components';

interface GroupsEmptyStateProps {
  onNewGroup: () => void;
}

export const GroupsEmptyState: React.FC<GroupsEmptyStateProps> = ({
  onNewGroup,
}) => (
  <EmptyState
    title='No groups yet'
    description='Automatic groups appear after the first sync.'
    action={<Button onClick={onNewGroup}>New group</Button>}
  />
);
